import { Button, Modal } from 'antd'
import React, { useState } from 'react'
import { deleteData } from '../../resources';
import { DeleteOutlined } from '@ant-design/icons';

export default function VisitaDelete({ id_visita, getVisitas }) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOk = () => {
        deleteData(`visitas/remove/${id_visita}`).then(() => {
            getVisitas();
        });
        setIsModalOpen(false);
    }

    const handleCancel = () => {
        setIsModalOpen(false);
    }

    return (
        <div>
            <Button type="primary" ghost danger onClick={() => setIsModalOpen(true)} icon={<DeleteOutlined />} style={{ marginBottom: 10  }} >
                Eliminar tratamiento
            </Button>

            <Modal title="Confirmar eliminación" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}
                okText="Sí, eliminar" cancelText="No, cancelar" okButtonProps={{ danger: true }}
            >
                <p>¿Está seguro de que desea eliminar este tratamiento? Esta acción no se puede deshacer.</p>
            </Modal>
        </div>
    )
}
